import * as z from 'zod';
/** En enhet av en produkt som räknas per artikel, att välja bland för en försäljningskanal. */
export const SalesChannelAssortmentUnit = z.object({
    id: z.int(),
    identifier: z.string(),
    is_available: z.boolean()
});
/**
 * En produkt som en försäljningskanal kan sälja, med om den gör det. Antal i hela enheter:
 * stock_quantity är det delade lagret, max_quantity hur många kanalen får ha bokade samtidigt
 * (null: ingen gräns), reservable_ids enheterna den säljer (null: alla, även nya).
 */
export const SalesChannelAssortmentProduct = z.object({
    reservable_product_id: z.int(),
    title: z.object({ sv: z.string() }).loose(),
    category: z.object({ id: z.int(), title: z.object({ sv: z.string() }).loose() }).loose(),
    is_individually_tracked: z.boolean(),
    stock_quantity: z.int(),
    units: z.array(SalesChannelAssortmentUnit),
    is_offered: z.boolean(),
    max_quantity: z.int().nullable(),
    reservable_ids: z.array(z.int()).nullable()
});
